import { jsx, jsxs } from "react/jsx-runtime";
import Group from "../../../layout/Group/Group.js";
import TextLink from "../../../navigation/TextLink/TextLink.js";
import Heading from "../../../typography/Heading/Heading.js";
import { rem } from "@mantine/core";
import { F as FooterStyles } from "../../../../Footer.module-DJ70l-Jq.js";
const ContentLinks = (props) => {
  const { links, ...rest } = props;
  return /* @__PURE__ */ jsx(Group, { className: FooterStyles.contentLinks, ...rest, children: links.map((group) => /* @__PURE__ */ jsxs(Group, { className: FooterStyles.linksGroup, direction: "column", children: [
    /* @__PURE__ */ jsx(Heading, { type: "h3", text: group.header, tt: "uppercase", variant: "light", mb: rem("16px") }),
    group.items.map((link) => /* @__PURE__ */ jsx(
      TextLink,
      {
        text: link.text,
        href: link.href,
        icon: "ChevronRight",
        color: "neutral",
        iconColor: "light",
        iconPlacement: "right",
        variant: link.variant ? link.variant : "footer",
        className: FooterStyles.link
      },
      link.text + link.href
    ))
  ] }, group.header)) });
};
export {
  ContentLinks as default
};
